import { render, staticRenderFns } from "./topCustomers.vue?vue&type=template&id=7d31fadc&scoped=true&"
import script from "./topCustomers.vue?vue&type=script&lang=js&"
export * from "./topCustomers.vue?vue&type=script&lang=js&"
import style0 from "./topCustomers.vue?vue&type=style&index=0&id=7d31fadc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d31fadc",
  null
  
)

export default component.exports